/**
 * @format
 * @description Non-sponsored (regular) video article page. This empty category exists to prevent
 * video pages from getting the (default) `standardSection` category.
 */
export default {
  mobile: {},
  portrait: {},
  landscape: {},
  desktop: {}
};
